import React from "react";
import Section2_menu from "../components-index/component-section2-index/menu";
import Section2_title from "../components-index/component-section2-index/title";
import Section2_product from "../components-index/component-section2-index/products";

function Menu_content(){

    return(
        <div id="menu">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <Section2_title />
                        <Section2_menu />
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Menu_content;